<template>
    <div class="company-info" :class="className">
        <div class="company-info-title" v-if="tag === 'list'">
            <span>
                {{title}}
            </span>

            <span>
                {{titleDes}}
            </span>
        </div>

        <div class="content-box">
          <div class="company-info-title" v-if="tag !== 'list'">
            <span style="overflow: hidden;white-space: nowrap;text-overflow: ellipsis; ">
                {{title}}
            </span>
          </div>
            <div class="img-box" >
                <img :src="imgUrl" class="preview-img">
            </div>

            <div class="product-info-box" >
                <div>
                    <div class="title-box">
                        <span style=" display: -webkit-box; -webkit-line-clamp: 2;-webkit-box-orient: vertical;overflow: hidden; text-overflow: ellipsis; line-height: 1.5;height: 3em; ">{{name}}</span>
                    </div>

                    <div class="title-box" v-if="null != subName">
                        <span>{{subName}}</span>
                    </div>

                    <div class="text-box" v-if="tag === 'list'">
                        <span>{{description}}</span>
                    </div>
                </div>

                <div class="shop-info">
                  <div v-show="null != refercost && refercost !== 0&&refercost!==cost">
                    &nbsp;<span   style="text-decoration: line-through;font-size: 12px;">$ {{refercost}}</span>
                  </div>
                    <div>
                        &nbsp;<span v-show="null != cost" class="price-span">$ {{cost}}</span>
                    </div>

                    <div>
                      <el-button plain type="primary" text @click="goShopEvent"  v-if="type ==='buy'"><font-awesome-icon style="height: 1.5em;color: #2e2c2c" icon="fa-solid fa-cart-shopping"  /></el-button>
                        <el-button plain type="primary" text @click="goShopEvent"  v-if="type !=='buy' && type !== 'agentmaterial'">{{btnLabel}}</el-button>
                      <el-button plain type="primary" text @click="goShopEvent"  v-if="type === 'agentmaterial'">{{btnLabel}}</el-button>
                    </div>
                </div>
            </div>

        </div>


    </div>
</template>

<script setup>
import {computed, getCurrentInstance, inject} from 'vue'
import myUtil from "@/util/util";
import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";
import {faCartShopping, faMobileScreenButton, faXmark} from '@fortawesome/free-solid-svg-icons'
import {library} from "@fortawesome/fontawesome-svg-core";

library.add(faCartShopping)
let { proxy } = getCurrentInstance();

const props = defineProps(["type","tag", 'obj', 'title', 'titleDes', 'imgUrl', 'name', 'subName', 'description', 'refercost','cost', 'btnLabel'])
const emits = defineEmits(['click-go-shop','clickshowMaterial'])

const i18n = inject("i18n")

const className = computed(() => {
    let name = "company-info-block"

    if(null != props.tag && props.tag === "list"){
        name = "company-info-list"
    }

    return name
})

function goShopEvent() {
    emits("click-go-shop", props.obj)
}
function showMaterial() {
  emits("clickshowMaterial", props.obj)
}
</script>

<style scoped>
.company-info {
    border: 1px #DCDFE6 solid;
    line-height: 2;
    padding: 10px;
    box-sizing: border-box;
    border-radius: 5px;
}

.company-info:nth-child(even) {
    background: #f9f9f9;
}

.company-info-title {
    text-align: left;
    font-weight: 600;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.company-info-block .shop-info {
    text-align: center;
    line-height: 1.5;
}

.company-info-list .shop-info {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.price-span {
    color: #e83f33;
    font-weight: 600;
}

.company-info-block .content-box {
    //display: flex;
}

.company-info-list .content-box {
    display: flex;
}

.company-info-block .img-box {
    width: 100%;
    padding-top: 100%;
    position: relative;
}

.company-info-list .img-box {
    width: 80px;
    height: 80px;
}

.company-info-block .preview-img {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    border: 1px #d6d6d6 solid;
    position: absolute;
    left: 0;
    top: 0;
}

.company-info-list .preview-img {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    border: 1px #d6d6d6 solid;
}

.company-info-block .product-info-box {
    //width: calc(100% - 80px);
    width: 100%;
    box-sizing: border-box;
    padding-left: 5px;
}

.company-info-list .product-info-box {
    width: calc(100% - 80px);
    box-sizing: border-box;
    padding-left: 5px;
}

.company-info-block .product-info-box .title-box {
    font-size: 14px;
    text-align: center;
    line-height: 2;
    //padding-bottom: 5px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 2;
}

.company-info-list .product-info-box .title-box {
    font-size: 14px;
    text-align: left;
    line-height: 2;
    padding-bottom: 5px;
}

.product-info-box .text-box {
    font-size: 12px;
    text-align: left;
    line-height: 1.5;
    color: #666;
    min-height: 3em;
}
</style>